import Anchor from 'sd-ui/dist/commonjs/components/Anchor/Anchor';
import PropTypes from 'prop-types';
import DownloadFileLabel from './downloadFileLabel';
import ExtraPropTypes from '../extraPropType';
import Icon from '../../icon';
import { createAssetLink } from '../../../utils/linkCreator';
import trackExtraFileDownload from '../../../utils/trackers/trackExtraFileDownload';

export default function DownloadSingleExtraFile({ file, pii, adobeContentType }) {
  const {
    extension, fileSize, label, type, eid,
  } = file;
  const displayLabel = extension && fileSize
    ? <DownloadFileLabel {...file} />
    : label;

  return (
    <Anchor
      icon={Icon.Download}
      href={createAssetLink(eid)}
      iconPlacement="left"
      hasBackgroundColor={false}
      target="_blank"
      className="call-to-action extras-popover-download-action"
      onClick={() => trackExtraFileDownload(pii, `MIME-${type}`, adobeContentType)}
    >
      {displayLabel}
    </Anchor>
  );
}

DownloadSingleExtraFile.propTypes = {
  pii: PropTypes.string.isRequired,
  file: PropTypes.shape(ExtraPropTypes).isRequired,
  adobeContentType: PropTypes.string,
};

DownloadSingleExtraFile.defaultProps = {
  adobeContentType: undefined,
};
